export default function sendClarityEvent(eventName) {
  if (!eventName || typeof window.clarity !== "function") return

  window.clarity("event", eventName)
  window.clarity("upgrade", eventName)
}
